import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const CreatePluginApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePluginApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pluginId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPluginApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pluginId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"apiKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowedOrigins"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CreatePluginApplication","document":CreatePluginApplicationDocument}} as const;
export type CreatePluginApplicationMutationVariables = Types.Exact<{
  key?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pluginId: Types.Scalars['String']['input'];
}>;


export type CreatePluginApplicationMutation = (
  { __typename: 'Mutation' }
  & { createPluginApplication?: Types.Maybe<(
    { __typename: 'Application' }
    & Pick<Types.Application, 'id' | 'allowedOrigins' | 'key' | 'secret'>
  )> }
);

export type CreatePluginApplicationMutationFn = Apollo.MutationFunction<
  CreatePluginApplicationMutation,
  CreatePluginApplicationMutationVariables
>;

/**
 * __useCreatePluginApplicationMutation__
 *
 * To run a mutation, you first call `useCreatePluginApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePluginApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPluginApplicationMutation, { data, loading, error }] = useCreatePluginApplicationMutation({
 *   variables: {
 *      key: // value for 'key'
 *      pluginId: // value for 'pluginId'
 *   },
 * });
 */
export function useCreatePluginApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePluginApplicationMutation,
    CreatePluginApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePluginApplicationMutation,
    CreatePluginApplicationMutationVariables
  >(CreatePluginApplicationDocument, options);
}
export type CreatePluginApplicationMutationHookResult = ReturnType<
  typeof useCreatePluginApplicationMutation
>;
export type CreatePluginApplicationMutationResult =
  Apollo.MutationResult<CreatePluginApplicationMutation>;
export type CreatePluginApplicationMutationOptions = Apollo.BaseMutationOptions<
  CreatePluginApplicationMutation,
  CreatePluginApplicationMutationVariables
>;
